export const GET_USER_PERMISSIONS = 'GET_USER_PERMISSIONS';
export const GET_USER_PERMISSIONS_SUCCEEDED = 'GET_USER_PERMISSIONS_SUCCEEDED';
export const GET_USER_PERMISSIONS_FAILED = 'GET_USER_PERMISSIONS_FAILED';


